import IconButton from "@components/icon-button";
import CutleryIcon from "@components/icons/cutlery-icon";
import { useAssistant } from "@features/assistant/assistant-provider";
import { Text, View } from "dripsy";
import * as React from "react";

function AssistantTriggerButton({ compact = false }: { compact?: boolean }) {
  const { toggle, isOpen } = useAssistant();

  return (
    <IconButton
      hitslop={15}
      backgroundColor={isOpen ? "$secondaryBackgroundPressed" : "$secondaryBackground"}
      onPress={toggle}
    >
      <View sx={{ height: 22, justifyContent: "center" }}>
        <CutleryIcon width={16} height={22} />
      </View>
      {compact ? null : (
        <Text
          numberOfLines={1}
          sx={{
            fontWeight: "500",
            pt: "$1",
            fontSize: [10, 11, 13],
            color: "$textSecondary",
            maxWidth: [58, 70, 90],
          }}
        >
          DGV hulp
        </Text>
      )}
    </IconButton>
  );
}

export default AssistantTriggerButton;
